<p-toast></p-toast>
<p-confirmDialog></p-confirmDialog>

<div>
  <!-- Search Input -->
  @if ((paginatedIssues && paginatedIssues.items.length) || searchControl.value) {
    <div class="mx-4 mb-4 flex items-center justify-end gap-2 sm:mx-0">
      <div class="w-full md:w-1/3">
        <p-inputGroup>
          <p-inputGroupAddon>
            <i class="pi pi-search"></i>
          </p-inputGroupAddon>
          <input
            type="text"
            pInputText
            [formControl]="searchControl"
            placeholder="{{ 'issues.table.search' | translate }}"
            class="w-full"
          />
          @if (searchControl.value) {
            <p-inputGroupAddon>
              <button
                class="p-inputgroup-addon cursor-pointer"
                (click)="clearSearch()"
              >
                <i class="pi pi-times"></i>
              </button>
            </p-inputGroupAddon>
          }
        </p-inputGroup>
      </div>
    </div>
  }

  <!-- Loading Indicator -->
  @if (loading) {
    <div class="my-6 flex flex-col items-center justify-center">
      <!-- Tailwind Spinner -->
      <div class="relative h-14 w-14">
        <div class="absolute h-14 w-14 animate-spin rounded-full border-4 border-solid border-primary border-t-transparent"></div>
      </div>
      <span class="mt-3 font-medium">{{ 'common.loading' | translate }}</span>
    </div>
  }

  @if (error$ | async; as errorMessage) {
    @if (errorMessage) {
      <div class="surface-danger border-round mb-3 p-4 text-white">
        {{ errorMessage }}
      </div>
    }
  }

  <!-- Empty state when no issues and not loading -->
  @if (!loading && (!paginatedIssues || !paginatedIssues.items.length)) {
    <div class="p-5 text-center">
      <i class="pi pi-inbox mb-3 text-4xl text-gray-400"></i>
      <div class="text-xl text-gray-600">{{ 'issues.table.noIssues' | translate }}</div>
      <div class="mt-2 text-sm text-gray-500">{{ 'issues.table.noIssuesDescription' | translate }}</div>
    </div>
  }

  <!-- Table with issues -->
  @if (!loading && paginatedIssues && paginatedIssues.items.length > 0) {
    <p-table
      #dt
      [value]="paginatedIssues.items"
      [stripedRows]="true"
      styleClass="p-datatable-sm"
      [rowHover]="true"
      [tableStyle]="{ 'min-width': '60rem' }"
      responsiveLayout="scroll"
      breakpoint="1350px"
      (sortFunction)="onSort($event)"
      [customSort]="true"
      dataKey="id"
    >
      <ng-template pTemplate="header">
        <tr>
          <th
            style="vertical-align: middle"
            class="!px-2"
          >
            {{ 'common.id' | translate }}
          </th>

          <th
            [pSortableColumn]="'status'"
            style="vertical-align: middle"
            class="!px-2"
          >
            <div class="flex items-center justify-between">
              {{ 'issues.table.tablehead.status' | translate }}
              <span class="ml-1">
                @if (sortState.field === 'status' && sortState.direction === 'asc') {
                  <i class="pi pi-sort-up"></i>
                }
                @if (sortState.field === 'status' && sortState.direction === 'desc') {
                  <i class="pi pi-sort-down"></i>
                }
                @if (sortState.field !== 'status') {
                  <i class="pi pi-sort text-300"></i>
                }
              </span>
            </div>
          </th>
          <th
            style="vertical-align: middle"
            class="!px-2"
          >
            {{ 'issues.table.tablehead.actions' | translate }}
          </th>
        </tr>
      </ng-template>
      <ng-template
        pTemplate="body"
        let-issue
      >
        <tr>
          <td>{{ issue.ID }}</td>
          <td class="!px-2">{{ issue.reportedBy.name }}</td>
          <td class="!px-2">
            <div class="flex gap-2">
              <button
                pButton
                icon="pi pi-pencil"
                class="p-button-rounded p-button-text p-button-sm"
                (click)="onEdit(issue)"
              ></button>
              <button
                pButton
                icon="pi pi-trash"
                class="p-button-rounded p-button-text p-button-danger p-button-sm"
                (click)="onDelete(issue)"
              ></button>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>

    <!-- Shared Paginator -->
    <app-pagination
      [pageSize]="pageSize"
      [currentPage]="currentPage"
      [totalItems]="paginatedIssues.totalCount"
      (pageChange)="onPaginationChange($event)"
    ></app-pagination>
  }
</div>
